
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/register.html",
      function () {
        return require("private-next-pages/authentication/register.html.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/register.html"])
      });
    }
  